import { Component, QueryList, ViewChildren, ChangeDetectorRef, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { MatDialog, MatSelect } from '@angular/material';
import { DatosGeneralesSAE } from '../../../datos-generales-SAE';
import { Entrada } from '../../../models/entradaAlmacen';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { switchMap, map } from 'rxjs/operators';

@Component({
  selector: 'agregarEntrada-component',
  styles: [],
  templateUrl: './agregarEntrada.component.html',
  providers: [generalService]
})

export class agregarEntradaComponent {
  constructor(private formBuilder: FormBuilder,
    private _generalService: generalService,
    public dialog: MatDialog,
    public dataService: DataService,
    private ref: ChangeDetectorRef,
    private router: Router,) {

    this.entradaForm = new FormGroup({});
    this.entradaModel = new Entrada();
    this.entradaModel.idSucursal = this.idSucursal;
    this.entradaModel.idUsuario = this.idUsuario;
    this.productosList = new Array();
    this.productosDeleted = new Array();


    if (this.dataService.tipo === "editar") {
      this.isUpdate = true;
      this.idEntrada = this.dataService.id;
      this.datosGeneralesSAE = DatosGeneralesSAE;
    }

    if (this.dataService.tipo === "ver") {
      this.isUpdate = true;
      this.readOnly = true;
      this.idEntrada = this.dataService.id;
      this.datosGeneralesSAE = DatosGeneralesSAE;
    }
  }

  @Output() recargarHistorico = new EventEmitter<boolean>();

  public entradaForm: FormGroup;
  public entradaModel: Entrada;
  public tipoEntadas = [];
  public almacenes = [];
  public statusEntradas = [
    { statusEntrada: "Abierta", idStatusEntrada: 0 },
    { statusEntrada: "Cerrada", idStatusEntrada: 1 }];
  public idEntrada: number;

  public productoForm: FormGroup;
  public productosList: any;
  public noProducto: number = 0;
  public idRegistro: number;
  public idFamilia: number = 0;
  public idSubFamilia: number;
  public idProducto: number;
  public cantidad: number;
  public piezasContenedor: number;
  public piezasContenedorOriginal: number;
  public familias = [];
  public subfamilias = [];
  public productos = [];
  public filtroProductos = [];
  public productosDeleted: any;

  public datosGeneralesSAE: any;
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public idSucursal: any = this.userData.ORGANIZATION_ID;
  public idCompania: any = this.userData.COMPANY_ID;
  public idUsuario: any = this.userData.USER_ID;
  public isUpdate: boolean = false;
  public readOnly: boolean = false;

  @ViewChildren('infiniteSelect') selectElem: QueryList<MatSelect>;


  ngOnInit() {
    this.buildForms();
    this.tipoEntradaGetList();
    this.almacenesGetList();
    this.familiasGetlist();
    this.subFamiliasGetList();
    this.productosGetList();
  }

  buildForms() {
    this.entradaForm = this.formBuilder.group({
      noEntrada: this.formBuilder.control({ value: null, disabled: true }),
      tipoEntrada: this.formBuilder.control(null, [Validators.required]),
      almacen: this.formBuilder.control(null, [Validators.required]),
      statusEntrada: this.formBuilder.control(null, [Validators.required]),
      observaciones: this.formBuilder.control(null)
    });
    this.productoForm = this.formBuilder.group({});

    if (this.isUpdate) {
      this.entradaForm.disable();
      this.entradaForm.controls['statusEntrada'].enable();
    }

    if (this.readOnly) {
      this.entradaForm.disable();
    }
  }

  tipoEntradaGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCall('EntradaAlmacen/tipoEntradaGetList')
        .subscribe(result => {
          result = JSON.parse(result);
          this.tipoEntadas = result;
          resolve();
        }, error => {
          reject();
        });
    });
  }

  almacenesGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idSucursal, 'EntradaAlmacen/almacenesGetList')
        .subscribe(result => {
          result = JSON.parse(result);
          this.almacenes = result;
          resolve();
        }, error => {
          reject();
        });
    });
  }

  onSubmit() {
    console.log("Submit del controller agregarEntrada");
    let tipo = 'agregar';
    let link = 'EntradaAlmacen/entradaInsert/';
    this.entradaModel.fechaRegistro = moment().format('YYYY-MM-DD HH:mm:ss');
    this._generalService
      .metodoCallParamsPutPost(tipo, this.entradaModel, link)
      .subscribe(result => {
        result = JSON.parse(result);
        this.idEntrada = result[0].idEntrada;
        this.entradaDetallesInsert(this.idEntrada);
        this._generalService
          .toastCall("Entrada registrada correctamente");
        this._generalService
          .sendClickEvent();
        this.entradaClean();
        this.router.navigate(['app/entrada']);
        this.recargarHistorico.emit();
      }, (error) => {
        const errorMsj = error as any;
        console.log(errorMsj);
      }
      );
  }

  productoFormAdd(noProducto: number) {
    this.productoForm.addControl('familiaProducto' + noProducto, this.formBuilder.control(null));
    this.productoForm.addControl('subFamiliaProducto' + noProducto, this.formBuilder.control(null));
    this.productoForm.addControl('nombreProducto' + noProducto, this.formBuilder.control(null, [Validators.required]));
    this.productoForm.addControl('cantidadProducto' + noProducto, this.formBuilder.control(null, [Validators.required]));
    this.productoForm.addControl('piezasContenedorProducto' + noProducto, this.formBuilder.control(null, []));
    this.productoForm.addControl('comentarioProducto' + noProducto, this.formBuilder.control(null, [Validators.maxLength(100)]));
  }

  productoFormRemove(noProducto: number) {
    this.productoForm.removeControl('familiaProducto' + noProducto,);
    this.productoForm.removeControl('subFamiliaProducto' + noProducto);
    this.productoForm.removeControl('nombreProducto' + noProducto);
    this.productoForm.removeControl('cantidadProducto' + noProducto);
    this.productoForm.removeControl('piezasContenedorProducto' + noProducto);
    this.productoForm.removeControl('comentarioProducto' + noProducto);
  }

  AddToList() {
    this.noProducto++;
    this.productoFormAdd(this.noProducto);
    this.productosList
      .push({
        noProducto: this.noProducto,
        idRegistro: this.idRegistro,
        idFamilia: this.idFamilia,
        idSubFamilia: this.idSubFamilia,
        idProducto: this.idProducto,
        cantidad: this.cantidad,
        piezasContenedor: this.piezasContenedor,
        piezasContenedorOriginal: this.piezasContenedorOriginal,
        comentarios: '',
        contenedorDecimales: false,
        statusRegistro: 1,
        itemsShow: 10,
        arrayFilteredProd: undefined,
        filteredItemsShow: 10,
        isFilteredProd: false,
        lstProductoFiltradas: this.productos.slice(0, 10),
        lstProducto: this.productos,
        searchProduct: undefined,
        idEntrada: 0,
        idUsuario: this.idUsuario,
        fechaUpdate: null,
        showPzContenedor: false
      });

    /***************************INFINITE SELECT**********************************/
    setTimeout(() =>
      this.selectElem.toArray().forEach(el => { el.onOpen.subscribe(() => this.registerPanelScrollEvent(el)); }),
      2);
    /***************************INFINITE SELECT**********************************/
  }

  removeFromList(indice) {
    let noProducto = this.productosList[indice].noProducto;

    if (this.productosList[indice].statusRegistro === 1) {
      this.productosList.splice(indice, 1);
    } else if (this.productosList[indice].statusRegistro === 2) {
      this.productosDeleted.push(this.productosList[indice]);
      this.productosList.splice(indice, 1);
    }
    this.productoFormRemove(noProducto);
    /***************************INFINITE SELECT**********************************/
    this.selectElem.toArray().splice(indice, 1);
    /***************************INFINITE SELECT**********************************/
  }

  familiasGetlist(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idCompania, 'descuento/consultFamilies')
        .subscribe(result => {
          result = JSON.parse(result);
          this.familias = result;
          resolve();
        }, error => {
          reject();
        });
    });
  }

  subFamiliasGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idCompania, 'descuento/consultSubFamilies')
        .subscribe(result => {
          result = JSON.parse(result);
          this.subfamilias = result;
          resolve();
        }, error => {
          reject();
        });
    });
  }

  productosGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idCompania, 'descuento/consultItem')
        .subscribe(result => {
          result = JSON.parse(result);
          this.productos = result;
          this.filtroProductos = result;
          if (this.isUpdate) {
            this.datosGeneralesSAE.showSpinnerLoading = true;
            this.entradaGetbyID();
            this.entradaDetalleGetList();
          }
          resolve();
        }, error => {
          reject();
        });
    });
  }

  productoPiezasGetValue(index, idItem): Promise<void> {
    for (let i = 0; i < this.productos.length; i++) {
      if (this.productos[i].itemId === idItem) {
        this.productosList[index].contenedorDecimales =
          this.productos[i].contenedorDecimales;
      }
    }

    let idProducto = this.productosList[index].idProducto;
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(idProducto, 'EntradaAlmacen/productoPiezasGetValue/')
        .subscribe(result => {
          result = JSON.parse(result);
          this.productosList[index].piezasContenedor = result[0].piezasContenedor;
          this.productosList[index].piezasContenedorOriginal = result[0].piezasContenedor;

          if (!this.productosList[index].contenedorDecimales && this.productosList[index].piezasContenedorOriginal == 1) {
            this.productosList[index].showPzContenedor = false;
          } else {
            this.productosList[index].showPzContenedor = true;
          }

          console.log(this.productosList[index]);
          resolve();
        }, error => {
          reject();
        });
    });
  }

  entradaDetallesInsert(idEntrada: number) {
    //for (let i = 0; i < this.productosList.length; i++) {
    /*let tipo = 'agregar';

    let registro = {
      idEntrada: idEntrada, 
      idRegistro: this.productosList[i].idRegistro,
      idProducto: this.productosList[i].idProducto, 
      cantidad: this.productosList[i].cantidad, 
      piezasContenedor: this.productosList[i].piezasContenedor,
      idUsuario: this.idUsuario,
      fechaUpdate: moment().format('YYYY-MM-DD HH:mm:ss')};

    let link;

    if (this.productosList[i].statusRegistro === 1) {
      link = 'EntradaAlmacen/entradaDetallesInsert/'; }
    if (this.productosList[i].statusRegistro === 2) {
      link = 'EntradaAlmacen/entradaDetallesUpdate/'; } */

    for (let i = 0; i < this.productosList.length; i++) {
      this.productosList[i].idEntrada = idEntrada;
      this.productosList[i].fechaUpdate = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    let params: any = [];
    for (let i = 0; i < this.productosList.length; i++) {
      let producAux = this.productosList[i]
      params.push({
        idEntrada: producAux.idEntrada,
        idRegistro: producAux.idRegistro,
        idProducto: producAux.idProducto,
        cantidad: producAux.cantidad,
        piezasContenedor: producAux.piezasContenedor,
        comentarios: producAux.comentarios,
        idUsuario: producAux.idUsuario,
        fechaUpdate: producAux.fechaUpdate,
        statusRegistro: producAux.statusRegistro,
      })
    }

    this._generalService
      .metodoCallParamsPutPost('agregar', params, 'EntradaAlmacen/entradaDetallesFunction/')
      .subscribe(result => {
        //result = JSON.parse(result);
        this.dataService.guardado = true;
      }, (error) => {
        const errorMsj = error as any;
        this._generalService.toastCall(errorMsj);
      });
    //}

    if (this.productosDeleted.length > 0) {
      for (let i = 0; i < this.productosDeleted.length; i++) {
        let registro = this.productosDeleted[i].idRegistro;
        this._generalService
          .metodoCallParams(registro, 'EntradaAlmacen/entradaDetallesDelete/')
          .subscribe(result => {
            if (result != "") {
              //this._generalService.toastCall(result);
            }
          },
            error => {
              var errorMsj = <any>error;
              console.log(errorMsj);
            });
      }
    }
  }

  // entradaClean() {
  //   this.productoForm.reset();
  //   this.entradaForm.reset();

  //   for (let i = 0; i <= this.productosList.length; i++) {
  //     this.productoFormRemove(i);
  //   }
  //   this.productosList.splice(0, this.productosList.length);

  //   this.entradaForm.enable();
  //   this.productoForm.enable();
  //   this.entradaForm.controls['noEntrada'].disable();
  // }

  entradaClean() {
  // Quitar controles dinámicos correctamente
  for (const prod of this.productosList) {
    this.productoFormRemove(prod.noProducto);
  }

  // Limpiar arreglos
  this.productosList = [];
  this.productosDeleted = [];

  // IMPORTANTÍSIMO: resetear el contador
  this.noProducto = 0;

  // Reset forms
  this.productoForm.reset();
  this.entradaForm.reset();

  // Re-habilitar
  this.entradaForm.enable();
  this.productoForm.enable();
  this.entradaForm.controls['noEntrada'].disable();
}


  entradaGetbyID(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idEntrada, 'EntradaAlmacen/entradaGetbyID/')
        .subscribe(result => {
          result = JSON.parse(result);
          this.entradaModel = result[0];
          resolve();
        }, error => {
          reject();
        });
    });
  }

  entradaDetalleGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idEntrada, 'EntradaAlmacen/entradaDetalleGetList/')
        .subscribe(result => {
          result = JSON.parse(result);
          this.productosList = result;
          for (let i = 0; i < this.productosList.length; i++) {
            this.noProducto = this.productosList[i].noProducto;
            this.productoFormAdd(this.noProducto);

            if (!this.productosList[i].contenedorDecimales && this.productosList[i].piezasContenedorOriginal == 1) {
              this.productosList[i].showPzContenedor = false;
            } else {
              this.productosList[i].showPzContenedor = true;
            }

            this.productosList[i].itemsShow = 10;
            this.productosList[i].arrayFilteredProd = undefined;
            this.productosList[i].filteredItemsShow = 10;
            this.productosList[i].isFilteredProd = false;
            this.productosList[i].lstProductoFiltradas = undefined;
            this.productosList[i].lstProducto = this.productos;
            this.productosList[i].searchProduct = undefined;

            /***************************INFINITE SELECT**********************************/
            const index = this.productosList[i].lstProducto.findIndex(x => x.itemId == this.productosList[i].idProducto);
            var a = this.productosList[i].lstProducto.splice(index, 1);
            this.productosList[i].lstProducto.unshift(a[0]);
            this.productosList[i].itemsShowProd = 10;
            this.productosList[i].lstProductoFiltradas = this.productosList[i].lstProducto.slice(0, 10);
            setTimeout(() =>
              this.selectElem.toArray().forEach(el => { el.onOpen.subscribe(() => this.registerPanelScrollEvent(el)); }),
              2);
            /***************************INFINITE SELECT**********************************/
          }
          if (this.readOnly) {
            this.productoForm.disable();
          }
          this.datosGeneralesSAE.showSpinnerLoading = false;
          resolve();
        }, error => {
          reject();
        });
    });
  }

  submitUpdate() {
    if (this.entradaModel.statusEntrada === 0) {
      this.entradaDetallesInsert(this.idEntrada);
      this._generalService.toastCall("La entrada se modificó exitosamente!");
      this.cerrarModal();
    } else {
      let fechaUpdate = moment().format('YYYY-MM-DD HH:mm:ss');
      let webService = 'EntradaAlmacen/entradaUpdate?idEntrada=' + this.idEntrada + '&&fechaUpdate=' + fechaUpdate;
      this._generalService
        .metodoCall(webService, true)
        .subscribe(result => {
          this.entradaDetallesInsert(this.idEntrada);
          this._generalService.toastCall("La entrada se modificó exitosamente!");
          this.cerrarModal();
        }, error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        });
    }
  }

  cerrarModal() {
    this.dataService.dialogRef.close();
  }

  // filtrarProducto(product: any) {
  //   let arr: any[];
  //   if (product.searchProduct) {
  //     product.arrayFilteredProd = product.lstProducto.filter((obj) => {
  //       return obj.name.toLowerCase().indexOf(product.searchProduct.toLowerCase()) > -1 ||
  //         ((obj.SKU) ? obj.SKU : '').toLowerCase().indexOf(product.searchProduct.toLowerCase()) > -1;
  //     });

  //     arr = product.arrayFilteredProd.slice(0, product.filteredItemsShow);
  //     product.isFilteredProd = true;
  //   }
  //   else {
  //     product.isFilteredProd = false;
  //     product.filteredItemsShow = 10;
  //     product.arrayFilteredProd = undefined;
  //     /***************************INFINITE SELECT**********************************/
  //     arr = product.lstProducto.slice(0, product.itemsShow);
  //     /***************************INFINITE SELECT**********************************/
  //   }
  //   product.lstProductoFiltradas = arr;
  // }

  private normalizeText(s: any): string {
    return (s ?? '')
      .toString()
      .toLowerCase()
      .normalize('NFD')                 // quita acentos
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, ' ')    // quita signos raros
      .replace(/\s+/g, ' ')
      .trim();
  }

  private tokenize(s: any): string[] {
    return this.normalizeText(s)
      .split(' ')
      .filter(t => t.length >= 2);      // ignora tokens muy cortos
  }

  filtrarProducto(product: any) {
    let arr: any[];

    const tokens = this.tokenize(product.searchProduct);

    if (tokens.length) {
      product.arrayFilteredProd = product.lstProducto.filter((obj: any) => {
        const haystack = this.normalizeText(
          `${obj.name || ''} ${obj.SKU || ''}`
        );

        // AND: todas las palabras deben coincidir
        return tokens.every(t => haystack.includes(t));
      });

      product.filteredItemsShow = 10;
      arr = product.arrayFilteredProd.slice(0, product.filteredItemsShow);
      product.isFilteredProd = true;
    } else {
      product.isFilteredProd = false;
      product.filteredItemsShow = 10;
      product.arrayFilteredProd = undefined;

      arr = product.lstProducto.slice(0, product.itemsShow);
    }

    product.lstProductoFiltradas = arr;
  }


  /***************************INFINITE SELECT**********************************/
  registerPanelScrollEvent(el) {
    const panel = el.panel.nativeElement;
    panel.addEventListener('scroll', event => this.loadAllOnScroll(event, el.id));
  }

  loadAllOnScroll(event, id: string) {
    const idProd = parseInt(id.replace('productoName', ''));
    if ((event.target.scrollTop + 1) >= (event.target.scrollHeight - event.target.offsetHeight)) {
      if (this.productosList[idProd].isFilteredProd) {
        if (this.productosList[idProd].filteredItemsShow < this.productosList[idProd].arrayFilteredProd.length) {
          this.productosList[idProd].filteredItemsShow += 10;
          this.productosList[idProd].lstProductoFiltradas = this.productosList[idProd].arrayFilteredProd.slice(0, this.productosList[idProd].filteredItemsShow);
          this.ref.detectChanges();
        }
      } else {
        if (this.productosList[idProd].itemsShow < this.productosList[idProd].lstProducto.length) {
          this.productosList[idProd].itemsShow += 10;
          this.productosList[idProd].lstProductoFiltradas = this.productosList[idProd].lstProducto.slice(0, this.productosList[idProd].itemsShow);
          this.ref.detectChanges();
        }
      }
    }
  }
  /***************************INFINITE SELECT**********************************/


  //SEGUNDA EDICIÓN DEL CODIGO, ACTUALIZACIONES E INCIDENCIAS
  validacionInputDecimales(e: any, valor: any, decimales: number, pszCont: any, permDec: any, item) {
    let numComp = valor + e.key;
    numComp = Number(numComp);

    if (permDec && pszCont == 1) {
      if (numComp > 1) {
        this._generalService.toastCall("No se permiten valores mayor a 1 en este producto");
      } else {
        this.inputNumerosConDecimales(e, valor, decimales);
      }
    }
    if (permDec && pszCont > 1) {
      this.inputNumerosConDecimales(e, valor, decimales);
    }
    if (!permDec && pszCont == 1) {
      this.productoForm.controls['piezasContenedorProducto' + this.productosList[item].noProducto].disable();
    }
    if (!permDec && pszCont > 1) {
      this.inputNumerosEnteros(e, valor);
    }
  }

  hasDecimalPlace(value: any, decimales: any) {
    // Verifica que solo cuente con las decimales que se establecio en el input
    const ed = value.split(".");
    if (ed.length > 1) {
      return ed[1].length > 2;
    }
    else {
      return false;
    }
  }

  inputNumerosConDecimales(e: any, valor: any, decimales: number): boolean {
    // Verifica que la tecla ingresada fuera copiar, pegar, eliminar, numeros o puntos decimales
    if ([8, 9, 13, 27, 46, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true)) {

      const character = String.fromCharCode(e.keyCode);
      valor = (valor) ? valor : '';
      const newValue: any = valor + character;
      // Verifica que no tenga más de un punto y que solo cuente con las decimales que se establecio en el input
      if (isNaN(newValue) || this.hasDecimalPlace(newValue, decimales)) {
        e.preventDefault();
        return false;
      }
      else {
        return;
      }
    }
    else {
      e.preventDefault();
      return false;
    }
  }

  inputNumerosEnteros(event: any, valor: any) {
    const e = event as KeyboardEvent;

    // Verifica que la tecla ingresada fuera copiar, pegar, eliminar o numeros 
    if ([8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) ||
      (e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) ||
      (e.keyCode === 88 && e.ctrlKey === true)) {
      return;
    }
    else {
      e.preventDefault();
      return false;
    }
  }

  onPaste(e: any) {
    e.preventDefault();
  }

  validacionesEntrada() {
    this.entradaForm.disable();
    this.productoForm.disable();
    if (this.productosList.length > 0) {
      let countVal = 0;
      let cantZero = 0;

      for (let i = 0; i < this.productosList.length; i++) {
        let canCont = this.productosList[i].cantidad;
        let pszCont = this.productosList[i].piezasContenedor;
        let pszOrig = this.productosList[i].piezasContenedorOriginal;
        let pzsTotl = canCont * pszCont;

        if (pzsTotl > 0) {
          if (pszOrig == 1 && pszCont > 1) {
            countVal = countVal + 1;
            this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].setValue(null);
          }
        } else {
          cantZero = cantZero + 1;
          if (canCont <= 0) {
            this.productoForm.controls['cantidadProducto' + this.productosList[i].noProducto].setValue(null);
          }
          if (pszCont <= 0) {
            this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].setValue(null);
          }
        }
      }

      if (this.isUpdate) {
        this.entradaForm.controls['statusEntrada'].enable();
        for (let i = 0; i < this.productosList.length; i++) {
          this.productoForm.controls['cantidadProducto' + this.productosList[i].noProducto].enable();
          this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].enable();
        }
      } else {
        this.entradaForm.enable();
        this.entradaForm.controls['noEntrada'].disable();
        for (let i = 0; i < this.productosList.length; i++) {
          this.productoForm.controls['nombreProducto' + this.productosList[i].noProducto].enable();
          this.productoForm.controls['cantidadProducto' + this.productosList[i].noProducto].enable();
          this.productoForm.controls['piezasContenedorProducto' + this.productosList[i].noProducto].enable();
        }
      }

      if (cantZero > 0) {
        this._generalService.toastCall("No se puede dar entrada a cantidades nulas o negativas.");
      } else {
        if (countVal > 0) {
          this._generalService.toastCall("Las piezas por contenedor de algunos productos no puede ser mayor a 1.");
        } else {
          if (this.isUpdate) {
            this.submitUpdate();
          } else {
            this.onSubmit();
          }
        }
      }
    } else {
      this._generalService.toastCall("Registra al menos un producto para guardar la Entrada.");
    }
  }

}




// WEBPACK FOOTER //
// ./src/app/almacen/entradas/agregar/agregarEntrada.component.ts